import { UserContentStatus } from "../types/typescript-axios";

export function translateProductReviewStatus(statusId: UserContentStatus) {
  if (statusId === 1) return '公開'
  if (statusId === 2) return '非公開'
  return '下書き' // 8
}